__turbopack_context__.v({
  "Popup": "index-module__ViXcIG__Popup",
  "Positioner": "index-module__ViXcIG__Positioner",
  "Trigger": "index-module__ViXcIG__Trigger",
});
